import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingState, EmptyState } from "@/components/common/EmptyState";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { notifIcon, timeAgo } from "@/lib/notifications";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/notifications");
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const open = async (n) => {
    if (!n.read) await api.put(`/notifications/${n.id}/read`).catch(() => {});
    if (n.link) navigate(n.link); else load();
  };
  const markAll = async () => { await api.put("/notifications/read-all").catch(() => {}); load(); };

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" subtitle="Stay on top of hearings, tasks and case activity."
        actions={<Button variant="outline" onClick={markAll} data-testid="notifications-mark-all"><CheckCheck className="mr-1.5 h-4 w-4" />Mark all read</Button>} />
      {!items ? <LoadingState /> : items.length === 0 ? (
        <EmptyState icon={Bell} title="No notifications" description="You're all caught up." testid="notifications-empty" />
      ) : (
        <Card className="divide-y divide-border border-border shadow-sm">
          {items.map((n) => {
            const Icon = notifIcon(n.type);
            return (
              <button key={n.id} onClick={() => open(n)} data-testid={`notification-row-${n.id}`}
                className={`flex w-full items-start gap-3 px-4 py-3.5 text-left transition-colors hover:bg-secondary/50 ${n.read ? "" : "bg-gold/5"}`}>
                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-navy/5 text-navy"><Icon className="h-4 w-4" /></div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-navy">{n.title}</p>
                  <p className="text-xs text-muted-foreground">{n.message}</p>
                  <p className="text-[11px] text-muted-foreground/70">{timeAgo(n.created_at)}</p>
                </div>
                {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gold" />}
              </button>
            );
          })}
        </Card>
      )}
    </div>
  );
}
